import apiFetch from '../apiFetch'

export default function (token, templateId) {
  return apiFetch({ endPoint: `template/${templateId}/current`, method: 'PUT', token: token })
}
